import axios from 'axios';
import store  from '../store';
import i18n from "../i18n";

const OnTableCart = {
  validateOrderOnTable() {
    if(store.state.ontable.tableId.toString().length > 0) {
      return axios({
        method: "get",
        url: `${process.env.VUE_APP_API_EXP}/menudigital/init?supplier_id=${store.state.customer.supplier.id}&table_code=${store.state.ontable.tableId}`,
      });
    }
  },
  validateActiveOrder() {
    return axios({
      method: "get",
      url: `${process.env.VUE_APP_API_EXP}/menudigital/init/${store.state.order.otPurchaseId}.json?customer_id=${store.state.customer.instance.id}&supplier_id=${store.state.customer.supplier.id}&service=${store.state.order.service}&table_code=${store.state.ontable.tableId}`,
      headers: {
        profileid: store.state.profile.profile.id,
        token: store.state.profile.profile.token
      }
    });
  },
  CookAddProductToCart(data) {
    return axios({
      method: "post",
      url: `${process.env.VUE_APP_API_EXP}/menudigital/add_product_cart.json`,
      headers: {
        profileid: store.state.profile.profile.id,
        token: store.state.profile.profile.token
      },
      data: {
        product: data.product,
        purchase_id: data.purchase_id,
        data_purchase: data.data_purchase
      }
    })
  },
  AddProductToCart(product,otPurchaseId,data_purchase) {
    return axios({
      method: "post",
      url: `${process.env.VUE_APP_API_EXP}/menudigital/add_product_cart`,
      headers: {
        profileid: store.state.profile.profile.id,
        token: store.state.profile.profile.token
      },
      data: {
        product: product,
        purchase_id: otPurchaseId,
        data_purchase: data_purchase
      }
    })
  },
  AddProductToMyList(product,otPurchaseId,data_purchase) {
    return axios({
      method: "post",
      url: `${process.env.VUE_APP_API_EXP}/menudigital/add_product_cart`,
      headers: {
        profileid: store.state.profile.profile.id,
        token: store.state.profile.profile.token
      },
      data: {
        product: product,
        purchase_id: otPurchaseId,
        data_purchase: data_purchase
      }
    });
  },
  getProductsCart() {
    return new Promise((resolve, reject) => {
      axios({
        method: "get",
        url: `${process.env.VUE_APP_API_EXP}/menudigital/cart/${store.state.order.otPurchaseId}.json`,
        headers: {
          profileid: store.state.profile.profile.id,
          token: store.state.profile.profile.token
        }
      }).then(
          response => {
            resolve(response.data);
          }
      ).catch(error => {
        reject(error.message)
      });
    });
  },
  cookProducts(data,purchase_id) {
    return new Promise((resolve, reject) => {
      const url = `${process.env.VUE_APP_API_EXP}/menudigital/cook_products/${purchase_id}.json`;
      axios({
        method: "put",
        url: url,
        headers: {
          profileid: store.state.profile.profile.id,
          token: store.state.profile.profile.token
        },
        data: data
      }).then(
          response => {
            resolve(response.data);
          },
          error => {
            reject(error)
          }
      );
    });
  },
  updateOrder(data) {
    return axios({
      method: "put",
      url: `${process.env.VUE_APP_API_EXP}/menudigital/cart/${store.state.order.otPurchaseId}`,
      headers: {
        profileid: store.state.profile.profile.id,
        token: store.state.profile.profile.token
      },
      data: data
    });
  },
  callTheWaiter() {
    return axios({
      method: "put",
      url: `${process.env.VUE_APP_API_EXP}/menudigital/call_waiter/${store.state.order.otPurchaseId}`,
      headers: {
        profileid: store.getters['profile/profile_id'],
        token: store.getters['profile/profile_token']
      }
    });
  },
  createPurchaseEmpty(data) {
    return axios({
      method: "post",
      url: `${process.env.VUE_APP_API_EXP}/menudigital/init.json`,
      headers: {
        profileid: store.state.profile.profile.id,
        token: store.state.profile.profile.token
      },
      data: { purchase: data }
    });
  },
  saveTip(tip) {
    return axios({
      method: "put",
      url: `${process.env.VUE_APP_API_EXP}/menudigital/add_tip/${store.state.order.otPurchaseId}.json`,
      headers: {
        profileid: store.state.profile.profile.id,
        token: store.state.profile.profile.token
      },
      data: tip
    });
  },
  sentService(cart_id,cart_token,serviceRate) {
    return axios({
      method: "post",
      url: `${process.env.VUE_APP_API_EXP}/menudigital/rates.json?purchase_id=${cart_id}&token=${cart_token}`,
      data: { rate: serviceRate }
    });
  },
  getHistoryOrdersBySupplier() {
    return axios({
      method: "get",
      url: `${process.env.VUE_APP_API_EXP}/menudigital/my_orders.json?supplier_id=${store.state.customer.supplier.id}`,
      headers: {
        profileid: store.state.profile.profile.id,
        token: store.state.profile.profile.token
      }
    });
  },
  createPurchaseByManualPayment (amount) {
    return axios({
      method: "post",
      url: `${process.env.VUE_APP_API_EXP}/menudigital/manual_payment.json`,
      headers: {
        profileid: store.state.profile.profile.id,
        token: store.state.profile.profile.token
      },
      data: {
        supplier_id: store.state.customer.supplier.id,
        amount
      }
    });
  },
  updatePurchaseByManualPayment (data) {
    return axios({
      method: "put",
      url: `${process.env.VUE_APP_API_EXP}/menudigital/manual_payment/${store.state.order.otPurchaseId}.json`,
      headers: {
        profileid: store.state.profile.profile.id,
        token: store.state.profile.profile.token
      },
      data
    });
  },
  formatValue(value) {
    return i18n.n(value, "currency", store.state.customer.instance.locale);
  },
  deleteAllProductsInCart () {
    return axios({
      method: "DELETE",
      url: `${process.env.VUE_APP_API_EXP}/menudigital/clean_cart/${store.state.order.otPurchaseId}.json`
    });
  },
  receiveOrder(otPurchaseId) {
    return axios({
      method: "put",
      url: `${process.env.VUE_APP_API_EXP}/menudigital/receive_order/${otPurchaseId}`,
      headers: {
        profileid: store.getters['profile/profile_id'],
        token: store.getters['profile/profile_token']
      }
    });
  },
}
const RateOnTable = {
  SendRateOnTable(data) {
    data.sesion_id = store.getters['profile/session_id'];
    return axios({
      method: "post",
      url: `${process.env.VUE_APP_API_EXP}/menudigital/rates_services.json`,
      data: {rates_service: data}
    });
  }
}

export { OnTableCart,RateOnTable }
